var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.dialogVisible
    ? _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("billingPage.ChoseCategories"),
            visible: _vm.dialogVisible,
            width: "1100px",
            "before-close": _vm.handleCancel,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("el-form", { attrs: { inline: true } }, [
            _c(
              "div",
              { staticStyle: { padding: "0 20px" } },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("billingPage.searchName") } },
                  [
                    _c("BjInput", {
                      attrs: {
                        placeholder: _vm.$t("inputText"),
                        clearable: "",
                      },
                      model: {
                        value: _vm.keywords,
                        callback: function ($$v) {
                          _vm.keywords = $$v
                        },
                        expression: "keywords",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-button",
                  {
                    staticStyle: { "margin-left": "10px" },
                    attrs: { type: "primary" },
                    on: { click: _vm.search },
                  },
                  [_vm._v(_vm._s(_vm.$t("searchText")))]
                ),
              ],
              1
            ),
            _c(
              "div",
              {
                staticStyle: {
                  height: "70vh",
                  "overflow-y": "auto",
                  padding: "0 20px",
                },
              },
              _vm._l(_vm.tableList, function (item, index) {
                return _c(
                  "div",
                  { key: index },
                  [
                    _c("BjDivider", [
                      _vm._v(_vm._s(item.group) + " "),
                      _c(
                        "div",
                        {
                          staticClass: "flex-align",
                          attrs: { slot: "right" },
                          slot: "right",
                        },
                        [
                          _c("el-button", {
                            attrs: {
                              icon: "el-icon-arrow-up",
                              circle: "",
                              disabled: !item.show,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.hiddenList(item)
                              },
                            },
                          }),
                          _c("el-button", {
                            attrs: {
                              icon: "el-icon-arrow-down",
                              disabled: item.show,
                              circle: "",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.openList(item)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _c(
                      "transition",
                      { attrs: { name: "el-fade-in-linear" } },
                      [
                        _c(
                          "el-table",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: item.show,
                                expression: "item.show",
                              },
                            ],
                            ref: "toggleTable" + index,
                            refInFor: true,
                            staticStyle: { width: "100%" },
                            attrs: {
                              id: "toggleTable" + index,
                              data: item.billCategories,
                              border: "",
                            },
                            on: {
                              "selection-change": function ($event) {
                                return _vm.handleSelectionChange($event, index)
                              },
                            },
                          },
                          [
                            _c("el-table-column", {
                              attrs: { type: "selection", width: "55" },
                            }),
                            _c("el-table-column", {
                              attrs: {
                                prop: "billCategoryName",
                                label: _vm.$t("billingPage.name"),
                                align: "center",
                                "min-width": "100",
                              },
                            }),
                            _c("el-table-column", {
                              attrs: {
                                prop: "billCategoryCode",
                                label: _vm.$t("billingPage.code"),
                                align: "center",
                                "min-width": "100",
                              },
                            }),
                            _c("el-table-column", {
                              attrs: {
                                prop: "description",
                                label: _vm.$t("billingPage.description"),
                                align: "center",
                                "min-width": "200",
                              },
                            }),
                            _c("el-table-column", {
                              attrs: {
                                prop: "tags",
                                label: _vm.$t("billingPage.tag"),
                                align: "center",
                                "min-width": "80",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              }),
              0
            ),
          ]),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              staticStyle: { padding: "0 20px" },
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.handleCancel } }, [
                _vm._v(_vm._s(_vm.$t("cancelText"))),
              ]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.handleSend } },
                [_vm._v(_vm._s(_vm.$t("okText")))]
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }